import React, { useEffect, Suspense, lazy, createElement } from 'react';
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ProductShowcase = lazy(() => import('./components/ProductShowcase').then(m => ({
  default: m.ProductShowcase
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Countdown = lazy(() => import('./components/Countdown').then(m => ({
  default: m.Countdown
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const ProBusiness = lazy(() => import('./components/ProBusiness').then(m => ({
  default: m.ProBusiness
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const DarkCTA = lazy(() => import('./components/DarkCTA').then(m => ({
  default: m.DarkCTA
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseNotifications = lazy(() => import('./components/PurchaseNotifications').then(m => ({
  default: m.PurchaseNotifications
})));
const HERO_BASE = 'https://res.cloudinary.com/dowzlbqlz/image/upload';
const HERO_PATH = '/v1778382523/hf_20260509_035726_3b0b453a-cd00-4b5f-b77d-c15b35a1d726-Photoroom_1_g1m6xf.webp';
const HERO_IMG = `${HERO_BASE}/f_auto,q_auto,w_800,c_limit${HERO_PATH}`;
const HERO_SRCSET = `${HERO_BASE}/f_auto,q_auto,w_400,c_limit${HERO_PATH} 400w, ${HERO_BASE}/f_auto,q_auto,w_600,c_limit${HERO_PATH} 600w, ${HERO_BASE}/f_auto,q_auto,w_800,c_limit${HERO_PATH} 800w`;
const OG_IMG = 'https://cdn.magicpatterns.com/uploads/9uMhQHg3RXXbKPqANDF9n5/hf_20260423_164447_343907b5-95aa-49ff-ba71-eeea9d0be6f6-Photoroom.webp';
export function App() {
  useEffect(() => {
    const runSeo = () => {
      document.title = 'Megapack Nutrición Resuelta — Sistema Nutricional Completo™';
      document.documentElement.lang = 'es';
      const setMeta = (name: string, content: string, property?: boolean) => {
        const attr = property ? 'property' : 'name';
        let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute(attr, name);
          document.head.appendChild(el);
        }
        el.content = content;
      };
      const description = 'El Sistema Nutricional Completo para nutricionistas argentinos. 6 Tomos clínicos, 6 Bonos de acción inmediata, Upsell de Autoridad Nutricional y materiales 100% editables. Todo lo que necesitás para resolver cada consulta, cada paciente y cada semana de trabajo. Acceso inmediato en PDF.';
      const url = 'https://nutricionresuelta.com';
      const image = OG_IMG;
      setMeta('description', description);
      setMeta('keywords', 'megapack nutrición resuelta, sistema nutricional completo, nutricionistas argentina, planes alimentarios listos, primera consulta nutrición, autoridad nutricional, casos clínicos resueltos, suplementación argentina, SOP nutrición, nutrición deportiva argentina, planillas editables nutrición');
      setMeta('robots', 'index, follow');
      setMeta('author', 'Biblioteca Profesional™');
      setMeta('viewport', 'width=device-width, initial-scale=1');
      if (!document.querySelector('link[rel="canonical"]')) {
        const canonical = document.createElement('link');
        canonical.rel = 'canonical';
        canonical.href = url;
        document.head.appendChild(canonical);
      }
      setMeta('og:title', 'Megapack Nutrición Resuelta — El Sistema Nutricional Completo™', true);
      setMeta('og:description', description, true);
      setMeta('og:image', image, true);
      setMeta('og:url', url, true);
      setMeta('og:type', 'product', true);
      setMeta('og:locale', 'es_AR', true);
      setMeta('og:site_name', 'Biblioteca Profesional™', true);
      setMeta('twitter:card', 'summary_large_image');
      setMeta('twitter:title', 'Megapack Nutrición Resuelta — Sistema Nutricional Completo™');
      setMeta('twitter:description', description);
      setMeta('twitter:image', image);
      if (!document.querySelector('script[data-ld="product"]')) {
        const ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.setAttribute('data-ld', 'product');
        ld.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'Megapack Nutrición Resuelta — Sistema Nutricional Completo™',
          description,
          image,
          brand: {
            '@type': 'Brand',
            name: 'Biblioteca Profesional™'
          },
          offers: {
            '@type': 'AggregateOffer',
            lowPrice: '24990',
            highPrice: '39990',
            priceCurrency: 'ARS',
            availability: 'https://schema.org/InStock',
            offerCount: 3
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '634'
          }
        });
        document.head.appendChild(ld);
      }
      if (!document.querySelector('script[data-ld="org"]')) {
        const orgLd = document.createElement('script');
        orgLd.type = 'application/ld+json';
        orgLd.setAttribute('data-ld', 'org');
        orgLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Biblioteca Profesional™',
          url,
          logo: image,
          email: 'hola@bibliotecaprofesional.com',
          sameAs: ['https://www.instagram.com/bibliotecaprofesional']
        });
        document.head.appendChild(orgLd);
      }
      if (!document.querySelector('script[data-ld="faq"]')) {
        const faqLd = document.createElement('script');
        faqLd.type = 'application/ld+json';
        faqLd.setAttribute('data-ld', 'faq');
        faqLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [{
            '@type': 'Question',
            name: '¿Qué incluye el Megapack Nutrición Resuelta?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '6 Tomos clínicos completos con sistema de primera consulta, 30 planes listos para personalizar, recetario con 100 recetas clínicas, protocolos de seguimiento, material educativo para entregar al paciente y 6 bonos profesionales incluyendo 15 casos clínicos resueltos, scripts de WhatsApp, guía de pacientes difíciles y más.'
            }
          }, {
            '@type': 'Question',
            name: '¿Cuáles son los tres niveles del sistema?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Nivel 1 — Megapack Nutrición Resuelta ($24.990): 6 Tomos + 6 Bonos. Nivel 2 — Autoridad Nutricional ($32.990): todo lo anterior + 4 Tomos de especialización clínica y modelo de negocio. Nivel 3 — Sistema Nutrición Completa ($39.990): todo lo anterior + materiales 100% editables, planillas y herramientas de implementación.'
            }
          }, {
            '@type': 'Question',
            name: '¿Cómo recibo el material?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Todo es 100% digital en formato PDF. Recibís acceso inmediato dentro de los 5 minutos posteriores a tu compra directamente en tu email.'
            }
          }, {
            '@type': 'Question',
            name: '¿Tiene garantía?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí. Ofrecemos garantía de 7 días sin preguntas. Si sentís que el sistema no resuelve tu consulta, te devolvemos el 100% de tu dinero.'
            }
          }, {
            '@type': 'Question',
            name: '¿Está adaptado a Argentina?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, 100%. Los planes, recetas, protocolos, marcas de suplementos y referencias clínicas están completamente adaptados al contexto argentino.'
            }
          }, {
            '@type': 'Question',
            name: '¿Para qué tipo de nutricionista es este sistema?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Para nutricionistas que atienden en consultorio presencial u online, tanto recién graduados como profesionales con años de experiencia, que quieren ahorrar tiempo, profesionalizar su servicio, aumentar la adherencia de sus pacientes y construir un negocio rentable.'
            }
          }, {
            '@type': 'Question',
            name: '¿Qué diferencia al nivel Autoridad Nutricional del Megapack base?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'El nivel Autoridad Nutricional incluye 4 Tomos adicionales de especialización: interpretación funcional de laboratorio, suplementación clínica con marcas argentinas, especialización en nutrición estética, deportiva y hormonal, y el modelo de negocio para armar programas de tratamiento de 12 semanas y talleres grupales.'
            }
          }]
        });
        document.head.appendChild(faqLd);
      }
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(runSeo, {
        timeout: 1500
      });
    } else {
      setTimeout(runSeo, 100);
    }
  }, []);
  useEffect(() => {
    const loadFbPixel = () => {
      if (typeof window !== 'undefined' && !(window as any).fbq) {
        const f = window as any;
        const n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        (window as any).fbq('init', '1215304437119773');
        (window as any).fbq('track', 'PageView');
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const s = document.getElementsByTagName('script')[0];
        s?.parentNode?.insertBefore(t, s);
      }
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadFbPixel, {
        timeout: 5000
      });
    } else {
      setTimeout(loadFbPixel, 5000);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1215304437119773&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>

      <header className="relative flex w-full flex-col items-center justify-center text-center text-gray-900 text-base leading-6 px-5 sm:px-6 py-12 sm:py-16" role="banner" style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      backgroundImage: 'linear-gradient(135deg, rgb(240,255,244) 0%, rgb(220,252,231) 30%, rgb(240,255,244) 60%, rgb(248,250,252) 100%)',
      backgroundColor: 'rgb(255, 255, 255)'
    }} data-id="element-2">
        {/* ── 1. BADGE ── */}
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-green-600/30 bg-white/80 px-4 py-1.5 shadow-sm" data-id="element-3">
          <span className="text-xs sm:text-sm font-bold text-green-700 tracking-wide uppercase" data-id="element-4">
            🥑 Sistema Clínico Profesional · Nutricionistas Argentina
          </span>
        </div>

        {/* ── 2. H1 ── */}
        <h1 className="sm:text-5xl md:text-[72px] sm:leading-snug md:leading-[88px] font-black max-w-4xl text-gray-900 m-0 mb-2 text-[28px] leading-10 tracking-tight" data-id="element-5">
          Dejá de perder horas
          <br data-id="element-6" />
          planificando desde cero.
          <br data-id="element-7" />
          <span className="text-green-700 mt-1 inline-block" data-id="element-8">
            Tu consultorio, resuelto.
          </span>
        </h1>

        {/* ── 3. MOCKUP ── */}
        <div className="my-6 sm:my-8 w-full max-w-[320px] sm:max-w-[380px] aspect-square relative" data-id="element-9">
          <div className="absolute inset-4 rounded-full z-0 pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(34,197,94,0.30) 0%, rgba(34,197,94,0.10) 50%, transparent 70%)'
        }} aria-hidden="true" data-id="element-10" />
          <img src={HERO_IMG} srcSet={HERO_SRCSET} sizes="(max-width: 640px) 320px, 380px" alt="Megapack Nutrición Resuelta — Sistema Nutricional Completo para Nutricionistas Argentina" width="400" height="400" fetchPriority="high" decoding="async" className="relative z-10 block max-w-full w-full h-auto object-contain" data-id="element-11" />
        </div>

        {/* ── 4. SUBTÍTULO ── */}
        <p className="max-w-xl text-base sm:text-lg font-semibold text-gray-700 leading-7 m-0 mb-4" data-id="element-12">
          El sistema que los nutricionistas más organizados de Argentina usan
          para llegar al consultorio preparados, entregar material clínico
          profesional y{' '}
          <span className="text-gray-900 font-black" data-id="element-13">
            cobrar lo que realmente vale su trabajo.
          </span>
        </p>

        {/* ── 5. NIVELES + CONTENIDO RESUMIDO ── */}
        <div className="mb-6 flex flex-col items-center gap-2 w-full max-w-sm" data-id="element-14">
          <div className="w-full flex items-center gap-3 rounded-xl border border-green-600/30 bg-white/80 px-4 py-2.5 shadow-sm" data-id="element-15">
            <span className="text-base" data-id="element-16">🥑</span>
            <div className="text-left" data-id="element-17">
              <p className="text-xs font-black text-green-700 uppercase tracking-wide m-0" data-id="element-18">
                Megapack Nutrición Resuelta
              </p>
              <p className="text-xs text-gray-500 font-medium m-0" data-id="element-19">
                6 Tomos · 6 Bonos · 30 planes · 100 recetas clínicas
              </p>
            </div>
          </div>
          <div className="w-full flex items-center gap-3 rounded-xl border border-green-600/40 bg-green-50/80 px-4 py-2.5 shadow-sm" data-id="element-20">
            <span className="text-base" data-id="element-21">⭐</span>
            <div className="text-left" data-id="element-22">
              <p className="text-xs font-black text-green-800 uppercase tracking-wide m-0" data-id="element-23">
                Autoridad Nutricional
              </p>
              <p className="text-xs text-gray-500 font-medium m-0" data-id="element-24">
                Todo lo anterior + 4 Tomos de especialización clínica
              </p>
            </div>
          </div>
          <div className="w-full flex items-center gap-3 rounded-xl border border-green-700/50 bg-green-100/80 px-4 py-2.5 shadow-sm" data-id="element-25">
            <span className="text-base" data-id="element-26">🏆</span>
            <div className="text-left" data-id="element-27">
              <p className="text-xs font-black text-green-900 uppercase tracking-wide m-0" data-id="element-28">
                Sistema Nutrición Completa
              </p>
              <p className="text-xs text-gray-500 font-medium m-0" data-id="element-29">
                Todo lo anterior + Materiales editables · Sin improvisar más
              </p>
            </div>
          </div>
        </div>

        {/* ── 6. CTA BUTTON ── */}
        <a href="#pricing" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Hero CTA Click',
            content_category: 'Nutrición Resuelta'
          });
        }
      }} className="block w-full max-w-sm bg-green-700 text-white text-lg sm:text-xl font-black rounded-xl px-6 sm:px-8 py-4 mb-4 no-underline text-center shadow-lg hover:opacity-90 transition-opacity" data-id="element-30">
          🥑 → QUIERO MI MEGAPACK AHORA
        </a>

        {/* ── 7. TRUST BADGES ── */}
        <div className="flex flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 m-0" data-id="element-31">
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-32">
            🛡️ Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-33">
            🔒 Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-34">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </header>

      <main data-id="element-35">
        <Suspense fallback={null} data-id="element-36">
          <SocialProof data-id="element-37" />
        </Suspense>
        <Suspense fallback={null} data-id="element-38">
          <div className="cv-auto" data-id="element-39">
            <PainPoints data-id="element-40" />
          </div>
          <div className="cv-auto" data-id="element-41">
            <ProductShowcase data-id="element-42" />
          </div>
        </Suspense>
        <Suspense fallback={null} data-id="element-43">
          <div className="cv-auto" data-id="element-44">
            <WhatYouGet data-id="element-45" />
          </div>
          <div className="cv-auto" data-id="element-46">
            <Bonuses data-id="element-47" />
          </div>
          <div className="cv-auto" data-id="element-48">
            <Countdown data-id="element-49" />
          </div>
          <div className="cv-auto" data-id="element-50">
            <Pricing data-id="element-51" />
          </div>
          <div className="cv-auto" data-id="element-52">
            <ProBusiness data-id="element-53" />
          </div>
          <div className="cv-auto" data-id="element-54">
            <Guarantee data-id="element-55" />
          </div>
          <div className="cv-auto" data-id="element-56">
            <Testimonials data-id="element-57" />
          </div>
          <div className="cv-auto" data-id="element-58">
            <FAQ data-id="element-59" />
          </div>
          <div className="cv-auto" data-id="element-60">
            <DarkCTA data-id="element-61" />
          </div>
          <FinalCTA data-id="element-62" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-63">
        <Footer data-id="element-64" />
        <PurchaseNotifications data-id="element-65" />
      </Suspense>
    </>;
}